(function () {
  'use strict';

  var APPLICATION_ENDPOINT = 'https://app.plumprint.com/api/affiliate-applications/';

  function initReels(root) {
    root.querySelectorAll('.pp-reel').forEach(function (reel) {
      var video = reel.querySelector('video');
      var overlay = reel.querySelector('.pp-reel-play');
      if (!video || video.dataset.ppWired) return;
      video.dataset.ppWired = '1';

      reel.addEventListener('click', function () {
        if (video.paused) {
          video.setAttribute('controls', '');
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', function () {
        if (overlay) overlay.style.opacity = '0';
      });
      video.addEventListener('pause', function () {
        if (overlay) overlay.style.opacity = '1';
      });
    });
  }

  function initApplyForm(root) {
    var form = root.querySelector('[data-partner-apply-form]');
    if (!form || form.dataset.ppWired) return;
    form.dataset.ppWired = '1';
    var success = root.querySelector('.pp-success');
    var submit = form.querySelector('[type="submit"]');
    var submitLabel = submit ? submit.textContent : '';
    var error = document.createElement('p');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    error.style.cssText = 'grid-column:1/-1;margin:0;color:#a12622;font-weight:700;text-align:center;';
    if (submit) form.insertBefore(error, submit);

    function setSubmitting(isSubmitting) {
      if (!submit) return;
      submit.disabled = isSubmitting;
      submit.textContent = isSubmitting ? 'Submitting…' : submitLabel;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submit && submit.disabled) return;

      error.hidden = true;
      setSubmitting(true);

      var data = new FormData(form);
      fetch(APPLICATION_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: data.get('name'),
          email: data.get('email'),
          platform: data.get('platform'),
          handle: data.get('handle'),
          source: data.get('source')
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('Application request failed');
        form.hidden = true;
        if (success) success.hidden = false;
      }).catch(function () {
        error.textContent = 'We could not submit your application. Please try again.';
        error.hidden = false;
        setSubmitting(false);
      });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('.pp-carousel').forEach(function (carousel) {
      var track = carousel.querySelector(':scope > div');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track || !prev || !next || track.dataset.ppCarouselWired) return;
      track.dataset.ppCarouselWired = '1';

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max - 4;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });

      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(update, 60);
      });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initFaq(root) {
    var items = root.querySelectorAll('.pp-faq-item');
    items.forEach(function (item) {
      var button = item.querySelector('.pp-faq-question');
      var answer = item.querySelector('.pp-faq-answer');
      var sign = item.querySelector('.pp-faq-sign');
      if (!button || !answer) return;

      button.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        items.forEach(function (other) {
          if (other === item) return;
          other.setAttribute('data-open', 'false');
          other.querySelector('.pp-faq-answer').hidden = true;
          other.querySelector('.pp-faq-sign').textContent = '+';
          other.querySelector('.pp-faq-question').setAttribute('aria-expanded', 'false');
        });
        var next = !isOpen;
        item.setAttribute('data-open', String(next));
        answer.hidden = !next;
        if (sign) sign.textContent = next ? '–' : '+';
        button.setAttribute('aria-expanded', String(next));
      });
    });
  }

  function initSmoothScroll(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      var targetId = link.getAttribute('href').slice(1);
      if (!targetId) return;
      link.addEventListener('click', function (event) {
        var target = document.getElementById(targetId);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    document.querySelectorAll('.pp-partner-program').forEach(function (root) {
      initReels(root);
      initApplyForm(root);
      initCarousels(root);
      initFaq(root);
      initSmoothScroll(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
